<section mat-dialog-content class="message-dialog-content">
	<div class="content-title margin-bottom-16">
		<p class="dz-text-16">{{ content.message.title }}</p>
	</div>
	<div class="spinner-container">
		<dz-progress-spinner></dz-progress-spinner>
	</div>
</section>
